import { Modal } from '../modal/modal';
import { OrgTreeItem } from '@employ-engage/data';
import chunk from 'lodash.chunk';
import cloneDeep from 'lodash.clonedeep';
import isEmpty from 'lodash.isempty';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { UPDATE_CURRENT_COMPANY } from '../api';
import { useMutation } from '@apollo/client';

export interface RenameOrgModalProps {
  itemLabel: string;
  path: (string | number)[];
  open: boolean;
  setOpen: (open: boolean) => void;
  completeOrgTree: OrgTreeItem;
  orgType: string;
  refetchCompany: () => void;
}

export function RenameOrgModal({
  itemLabel,
  path,
  open,
  setOpen,
  completeOrgTree,
  orgType,
  refetchCompany,
}: RenameOrgModalProps) {
  const { t } = useTranslation(['common']);
  const [updateCompany] = useMutation(UPDATE_CURRENT_COMPANY);
  const [newName, setNewName] = useState<string>('');
  const renameOrg = () => {
    const clonedOrgTree = cloneDeep(completeOrgTree);
    let ref: any | [] = clonedOrgTree;

    if (isEmpty(path)) {
      // do nothing
    } else {
      chunk(path, 2).forEach((item, index, chunks) => {
        const org = item[0];
        const arrayIndex = item[1];

        if (index === chunks.length - 1) {
          ref[org] = [
            ...ref[org].slice(0, arrayIndex),
            {
              ...ref[org][arrayIndex],
              name: newName,
            } as OrgTreeItem,
            ...ref[org].slice((arrayIndex as number) + 1),
          ];
        } else {
          ref = ref[org][arrayIndex];
        }
      });
    }

    updateCompany({ variables: { input: { orgTree: clonedOrgTree } } })
      .then(() => {
        setOpen(false);
        refetchCompany();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Modal open={open} setOpen={setOpen} panelClassName="w-full max-w-[400px]">
      <div>
        <h1 className="mb-3 text-lg font-bold">
          {t('rename-org-type', { orgType })}
        </h1>
        <p>
          <Trans i18nKey="rename_item" values={{ item: itemLabel }}>
            What do you want to rename{' '}
            <span className="font-bold">{itemLabel}</span> to?
          </Trans>
        </p>
        <input
          type="text"
          className="w-full border border-gray-300 rounded-md p-2"
          onChange={(e) => setNewName(e.target.value)}
        />
        <div className="mt-4 flex justify-end">
          <button className="mr-4" onClick={() => setOpen(false)}>
            {t('Cancel')}
          </button>
          <button
            onClick={renameOrg}
            disabled={!newName}
            className="rounded-md bg-indigo-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
          >
            {t('Rename')}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default RenameOrgModal;
